export default __webpack_public_path__ + "static/N0181-a321940e13f0ec77e6d3351807a3c07c.png";